import { render, staticRenderFns } from "./policyDetail.vue?vue&type=template&id=04862e98&scoped=true"
import script from "./policyDetail.vue?vue&type=script&lang=js"
export * from "./policyDetail.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/articleDetail.css?vue&type=style&index=0&id=04862e98&prod&scoped=true&lang=css&external"
import style1 from "./policyDetail.vue?vue&type=style&index=1&id=04862e98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04862e98",
  null
  
)

export default component.exports